// extracted by mini-css-extract-plugin
module.exports = {"privacy-policy":"privacy-policy_privacy-policy__2Q_DN"};